export default __webpack_public_path__ + "static/media/programmer.f0727d4f.png";